import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCsvExcelTradesHistoryService } from "@/features/accounts/csv-excel/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetCsvExcelTradesHistoryResponseModel } from "@/features/accounts/csv-excel/services/get-trades-history-model";

export const useGetCsvExcelTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getCsvExcelTradesHistoryService = new GetCsvExcelTradesHistoryService();

  // csv/Excel取込履歴取得
  const getCsvExcelTradesHistory = async (
    accountGroupId: string,
    csvexcelAccountId: string,
    offset?: string,
  ): Promise<GetCsvExcelTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getCsvExcelTradesHistoryService.getCsvExcelTradesHistory({
        account_group_id: accountGroupId,
        csvexcel_account_id: csvexcelAccountId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getCsvExcelTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getCsvExcelTradesHistory: errorHandledAsync(getCsvExcelTradesHistory, setError),
  };
};
